export const staticBaseURL = "https://eflow-static02-landing.s3.us-west-2.amazonaws.com/media/elements/";